import { render } from "./CouponTemplateMultiSelector.vue?vue&type=template&id=89595a02&scoped=true"
import script from "./CouponTemplateMultiSelector.vue?vue&type=script&lang=js"
export * from "./CouponTemplateMultiSelector.vue?vue&type=script&lang=js"

import "./CouponTemplateMultiSelector.vue?vue&type=style&index=0&id=89595a02&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1198/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89595a02"]])

export default __exports__